import service from "@/utils/request";

export const getAllReports = async (id = null) => {
    try {
        const url = id ? `leads/reports?id=${id}` : 'leads/reports'; // Add id to URL only if it's provided
        const response = await service.get(url);  // Make the request
        return response;
    } catch (e) {
        console.error("Failed to fetch Reports:", e);
    }
}